<template>
  <div id="travel">
    <Topbar
      v-if="this.$store.state.topbar_actions_visible"
      @action="fnAction"
    ></Topbar>
    <v-container class="main left" v-if="travel">
      <v-layout row wrap class="section-container" id="basic">
        <v-flex xs12 sm6 md3 class="logo">
          <img :src="travel.avatar ? travel.avatar : '/img/travel.svg'" />
        </v-flex>
        <v-flex xs12 sm6 md9 class="info">
          <v-container>
            <v-layout row wrap class="section">
              <v-flex xs12 class="name">{{ $t("basic_info") }}</v-flex>
              <v-flex xs12 md6>
                <div class="label">{{ $t("params.type") }}:</div>
                <div class="value">
                  {{ getTravelTypeName(travel.type) | checkParam }}
                </div>

                <div class="label">{{ $t("params.transport_mode") }}:</div>
                <div class="value" v-if="travel.transport_mode">
                  {{ transport_modes[travel.transport_mode][0] }}
                </div>
                <div class="label">{{ $t("params.transport_company") }}:</div>
                <div class="value">
                  {{ travel.transport_company | checkParam }}
                </div>

                <div class="label">{{ $t("params.cost") }}:</div>
                <div class="value">{{ travel.cost | checkParam }}{{ coin }}</div>

                <div class="label">{{ $t("params.contact_phone") }}:</div>
                <div class="value">{{ travel.contact_phone | checkParam }}</div>
              </v-flex>
              <v-flex xs12 md6>
                <div class="label">{{ $t("params.identifier") }}:</div>
                <div class="value">
                  #{{ travel.travel_number | checkParam }}
                </div>

                <div class="label">{{ $t("params.status") }}:</div>
                <div class="value">
                  {{ statusOptions[travel.status] | checkParam }}
                </div>

                <div class="label">{{ $t("params.bus_private") }}:</div>
                <div class="value">
                  {{ travel.bus_private | checkParam }}
                </div>

                <template v-if="travel.transport_mode == '1'">
                  <div class="label">{{ $t("params.n_flight") }}:</div>
                  <div class="value">{{ travel.n_flight | checkParam }}</div>
                </template>

                <template v-if="travel.transport_mode == '2'">
                  <div class="label">{{ $t("params.n_train") }}:</div>
                  <div class="value">{{ travel.n_train | checkParam }}</div>
                </template>

                <template v-if="travel.transport_mode == '3'">
                  <div class="label">{{ $t("params.n_bus") }}:</div>
                  <div class="value">{{ travel.n_bus | checkParam }}</div>
                </template>

                <div class="label">{{ $t("params.n_pax") }}:</div>
                <div class="value">{{ travel.pax | checkParam }}</div>

                <div class="label">{{ $t("params.contact_name") }}:</div>
                <div class="value">{{ travel.contact_name | checkParam }}</div>

                <div class="label">{{ $t("params.observations") }}:</div>
                <div class="value">{{ travel.observations | checkParam }}</div>

                <div class="label">{{ $t("params.observations_int") }}:</div>
                <div class="value">
                  {{ travel.observations_int | checkParam }}
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs12 sm12 md12 class="info">
          <v-container>
            <v-layout row wrap class="section">
              <v-flex xs12 class="name">{{ $t("params.origin") }}</v-flex>
              <v-flex xs12 md6>
                <template
                  v-if="travel.origin && travel.origin.entity_type != '0'"
                >
                  <div class="label">{{ $t("params.entity") }}:</div>
                  <div
                    class="value"
                    v-if="originLocations[travel.origin.entity_id]"
                  >
                    {{
                      originLocations[travel.origin.entity_id].name | checkParam
                    }}
                  </div>
                </template>

                <template v-else-if="travel.origin">
                  <div class="label">{{ $t("params.entity") }}:</div>
                  <div class="value">{{ travel.origin.name | checkParam }}</div>
                </template>

                <div class="label">{{ $t("params.origin_date") }}:</div>
                <div class="value" v-if="travel.origin">
                  {{ travel.origin.date | showDate }}
                </div>
              </v-flex>
              <v-flex xs12 md6>
                <div class="label">{{ $t("params.origin_city") }}:</div>
                <div
                  class="value"
                  v-if="
                    travel.origin &&
                      travel.origin.entity_type != '0' &&
                      originLocations[travel.origin.entity_id]
                  "
                >
                  {{
                    originLocations[travel.origin.entity_id].city | checkParam
                  }}
                </div>
                <div class="value" v-else-if="travel.origin">
                  {{ travel.origin.city | checkParam }}
                </div>

                <div class="label">{{ $t("params.origin_hour") }}:</div>
                <div class="value" v-if="travel.origin">
                  {{ travel.origin.date | showHourOnly }}
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs12 sm12 md12 class="info">
          <v-container>
            <v-layout row wrap class="section">
              <v-flex xs12 class="name">{{ $t("params.destination") }}</v-flex>
              <v-flex xs12 md6>
                <template
                  v-if="
                    travel.destination && travel.destination.entity_type != '0'
                  "
                >
                  <div class="label">{{ $t("params.entity") }}:</div>
                  <div
                    class="value"
                    v-if="destinationLocations[travel.destination.entity_id]"
                  >
                    {{
                      destinationLocations[travel.destination.entity_id].name
                        | checkParam
                    }}
                  </div>
                </template>

                <template v-else-if="travel.destination">
                  <div class="label">{{ $t("params.entity") }}:</div>
                  <div class="value">
                    {{ travel.destination.name | checkParam }}
                  </div>
                </template>

                <div class="label">{{ $t("params.destination_date") }}:</div>
                <div class="value" v-if="travel.destination">
                  {{ travel.destination.date | showDate }}
                </div>
              </v-flex>
              <v-flex xs12 md6>
                <div class="label">{{ $t("params.destination_city") }}:</div>
                <div
                  class="value"
                  v-if="
                    travel.destination &&
                      travel.destination.entity_type != '0' &&
                      destinationLocations[travel.destination.entity_id]
                  "
                >
                  {{
                    destinationLocations[travel.destination.entity_id].city
                      | checkParam
                  }}
                </div>
                <div class="value" v-else-if="travel.destination">
                  {{ travel.destination.city | checkParam }}
                </div>

                <div class="label">{{ $t("params.destination_hour") }}:</div>
                <div class="value" v-if="travel.destination">
                  {{ travel.destination.date | showHourOnly }}
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs12 sm12 md12 class="info">
          <v-container>
            <v-layout row wrap class="section">
              <v-flex xs12 class="name" style="margin-bottom: 5px;">{{
                $t("params.n_pax")
              }}</v-flex>
              <div
                class="person"
                v-for="(item, index) in travel.people"
                :key="index"
              >
                <div class="avatar" @click="goToTeamCard(item.entity_id)">
                  <v-img
                    class="shield"
                    v-if="item.entity_type == 2"
                    :src="item.shield"
                  ></v-img>
                  <div v-else class="letter">{{ item.name.charAt(0) }}</div>
                </div>
                <div class="content">
                  <div
                    class="entity-name"
                    v-if="item.entity_type == '2'"
                    @click="goToTeamCard(item.entity_id)"
                  >
                    {{ item.name }} ({{ item.category_name }})
                  </div>
                  <div
                    class="entity-name"
                    v-else
                    @click="goToTeamCard(item.entity_id)"
                  >
                    {{ item.name }}
                  </div>
                  <div class="pax">
                    <v-icon class="icon">person</v-icon>
                    <div class="number">{{ item.number }}</div>
                  </div>
                  <div class="actions" v-if="travel.people.length > 1">
                    <div
                      class="bifurcation"
                      @click="createBifurcation(item)"
                    ></div>
                    <div class="remove">
                      <v-icon @click="removeEntity(item)">delete</v-icon>
                    </div>
                  </div>
                </div>
              </div>
              <v-flex xs12 md6>
                <template>
                  <div class="label">
                    {{ $t("total") }} {{ $t("params.n_pax") }}:
                  </div>
                  <div class="value">
                    {{ travel.pax }}
                  </div>
                </template>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="section-container" id="basic">
        <v-flex xs12 sm12 md12 class="info">
          <v-container>
            <v-layout row wrap class="section">
              <LastUpdate :data="travel.user_modify"></LastUpdate>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Topbar from "@/components/ui/Topbar";

import Phone from "@/components/ui/labels/Phone";
import Email from "@/components/ui/labels/Email";
import Country from "@/components/ui/labels/Country";
import LastUpdate from "@/components/ui/LastUpdate";

export default {
  name: "CardTravel",
  components: { Topbar, Phone, Email, Country, LastUpdate },
  props: {},
  data() {
    return {
      travel: false,
      id: this.$route.params.id,
      current_roles: [],
      statusOptions: {
        "1": i18n.t("travels.status.1"),
        "2": i18n.t("travels.status.2")
      },
      // typeOptions removed; using computed travelTypes + getTravelTypeName
      locationOptions: {
        "4": i18n.t("hotels.label"),
        "5": i18n.t("facilitys.label"),
        "11": i18n.t("travels.other_location"),
        "0": i18n.t("travels.custom_location")
      },
      people: {},
      peopleArrayLoad: []
    };
  },
  computed: {
    travelTypes() {
      const getter = this.$store.getters['getTravelTypes']
      if (!getter) return []
      const raw = getter()
      if (!raw) return []
      const list = Array.isArray(raw) ? raw : Object.values(raw)
      return list.map(type => ({
        value: String(type.id),
        name: i18n.t(type.name)
      }))
    },
    coin(){
        let event = this.$store.getters[ 'events/getCurrentEvent' ]()
        return event.type_id == 15 ? '$' : '€'
    },
    country() {
      if (this.travel.country_id) {
        return {
          ...this.$store.getters.getCountryByID(this.travel.country_id)
        };
      }
      return {};
    },

    transport_modes() {
      var oOptions = this.$store.getters.getTransportMode();
      var aResult = [];
      for (var k in oOptions) {
        aResult[oOptions[k].id] = [];
        aResult[oOptions[k].id].push(
          i18n.t("travels.transport_mode." + oOptions[k].name)
        );
      }

      return aResult;
    },

    originLocations() {
      switch (this.travel.origin.entity_type) {
        case "4":
          return this.$store.getters["hotels/getListKeyId"]();
        case "5":
          return this.$store.getters["facilitys/getListKeyId"]();
        case "11":
          return this.$store.getters["travels/getLocations"]();
        default:
          return this.travel.origin;
      }
    },

    destinationLocations() {
      switch (this.travel.destination.entity_type) {
        case "4":
          return this.$store.getters["hotels/getListKeyId"]();
        case "5":
          return this.$store.getters["facilitys/getListKeyId"]();
        case "11":
          return this.$store.getters["travels/getLocations"]();
        default:
          return this.travel.destination;
      }
    },
    // Return a function so it can be invoked with an argument from the template
    getTravelTypeName () {
      return id => {
        if (!id) return ''
        const found = this.travelTypes.find(t => t.value === String(id))
        return found ? found.name : ''
      }
    }
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.$overlay.loading();

      var params = {};
      if (this.$store.state.event_selected) {
        params.event = this.$store.getters["events/getCurrentEvent"]().id;
      }
      this.$store.dispatch("travels/loadLocations", params);

      this.$store.commit("setTopbarActionsVisible", true);
      this.$store.commit("setMenuVisible", true);

      var id = this.$route.params.id;
      var self = this;
      this.$store.dispatch("travels/load_by_id", { id: id }).then(function() {
        let travel = {
          ...self.$store.getters["travels/get_by_id"](self.$route.params.id)
        };
        self.peopleArrayLoad = [...Object.values(travel.people)];
        travel.people = [];
        travel.bus_private =
          parseInt(travel.bus_private) == 1 ? "true" : "false";
        self.travel = JSON.parse(JSON.stringify(travel));
        self.loadPeople();
      });
    },
    getCountry(id) {
      if (id) {
        return { ...this.$store.getters.getCountryByID(id) };
      }
      return false;
    },

    goToTeamCard(id) {
      var route = "";
      if (this.$store.getters.isEventSelected) {
        var event = this.$store.getters["events/getCurrentEvent"]().id;

        route = this.$root.entityUrl("team", id, event);
      } else {
        route = this.$root.entityUrl("team", id);
      }
      this.$router.push(route);
    },

    removeEntity(item) {
      var self = this;
      let message = i18n.t("travels.remove_entity");
      message = message.replace(
        "[entity_name]",
        item.entity_type == 2 ? item.name + " " + item.category_name : item.name
      );
      this.$popup.confirm(
        {
          message: message,
          btnSuccess: i18n.t("accept"),
          btnError: i18n.t("cancel")
        },
        function() {
          self.$store
            .dispatch("travels/remove_relation", {
              travel_id: self.$route.params.id,
              rel: item.entity_id,
              type: item.entity_type
            })
            .then(() => {
              self.load();
            });
        }
      );
    },

    createBifurcation(item) {
      var self = this;
      let message = i18n.t("travels.create_bifurcation");
      message = message.replace(
        "[entity_name]",
        item.entity_type == 2 ? item.name + " " + item.category_name : item.name
      );
      this.$popup.confirm(
        {
          message: message,
          btnSuccess: i18n.t("accept"),
          btnError: i18n.t("cancel")
        },
        function() {
          self.$store
            .dispatch("travels/create_bifurcation", {
              travel_id: self.$route.params.id,
              rel: item.entity_id,
              type: item.entity_type
            })
            .then(function(id) {
              self.$popup.confirm(
                {
                  message: i18n.t("travels.go_to_travel_created"),
                  btnSuccess: i18n.t("accept"),
                  btnError: i18n.t("cancel")
                },
                function() {
                  self.$router.push({
                    name: self.$route.params.event
                      ? "event_travels_card"
                      : "travels_card",
                    params: { id: id, event: self.$route.params.event }
                  });

                  self.load();
                },
                function() {
                  self.load();
                }
              );
            });
        }
      );
    },

    fnAction(emit) {
      if (typeof emit.action === "undefined" || emit.action == null) return;
      switch (emit.action) {
        case "remove":
          this.fnRemove(emit.params);
          break;
        case "create_note":
          this.createNote(emit.params);
          break;
        case "create_relationship":
          this.createContactRelationship(emit.params);
          break;
        case "rel_club_event":
          this.fnRelClubEvent(emit.params);
          break;
        case "destroy":
          this.fnDestroy(emit.params);
          break;
      }
    },

    fnRemove() {
      var self = this;
      this.$popup.confirm(
        {
          message: i18n.t("travels.remove_message"),
          btnSuccess: i18n.t("accept"),
          btnError: i18n.t("cancel")
        },
        function() {
          self.$store.dispatch("travels/remove", self.id).then(function() {
            var event = self.$store.getters.isEventSelected
              ? self.$store.getters["events/getCurrentEvent"]()
              : false;
            var page = event ? "event_" : "";
            page = page + "travels";
            self.$router.push({
              name: page,
              params: {
                event: self.$root
                  .formatEventUrl(event.name, event.edition)
                  .replace("/event/", "")
              }
            });
          });
        }
      );
    },

    fnDestroy() {
      this.$destroy();
    },

    loadPeople() {
      if (Object.keys(this.peopleArrayLoad).length > 0) {
        var key = Object.keys(this.peopleArrayLoad)[
          Object.keys(this.peopleArrayLoad).length - 1
        ];
        var item = this.peopleArrayLoad[key];

        if (item.entity_type == "2") {
          var self = this;
          this.$store
            .dispatch("teams/load_by_id", { id: item.entity_id })
            .then(function(team) {
              var oTeam = {
                entity_type: 2,
                entity_id: item.entity_id,
                name: team.name,
                category_name: team.category.max_age,
                shield: team.club.shield,
                number:
                //   parseInt(Object.keys(team.players).length) +
                //   parseInt(Object.keys(team.staff).length) +
                //   parseInt(Object.keys(team.acompanyants).length)
                parseInt(team.estimate_players) +
                  parseInt(team.estimate_staff) +
                  parseInt(team.estimate_acompanyants)
              };
              self.travel.people.push(oTeam);
              self.loadPeople();
            });
        } else {
          var self = this;
          this.$store
            .dispatch("persons/load_by_id", { id: item.entity_id })
            .then(function(person) {
              var oPerson = {
                entity_type: 3,
                entity_id: item.entity_id,
                name: person.name,
                category_name: "",
                shield: "",
                number: 1
              };
              self.travel.people.push(oPerson);
              self.loadPeople();
            });
        }
        this.peopleArrayLoad.pop();
      } else {
        // this.travel.people = this.peopleLoaded;
        this.dataLoaded = true;
        this.$overlay.hide();
      }
    }

    // loadPeople() {
    //     console.log("hola");
    //     if ( Object.keys(this.peopleArrayLoad).length > 0 ) {
    //         var key = Object.keys(this.peopleArrayLoad)[Object.keys(this.peopleArrayLoad).length-1];
    //         var item = this.peopleArrayLoad[key];

    //         if (item.entity_type == '2') {
    //             var self = this;
    //             this.$store.dispatch( 'teams/load_by_id', { id: item.entity_id } ).then( function( team ){
    //                 var oTeam = {
    //                     entity_type: 2,
    //                     entity_id: item.entity_id,
    //                     name: team.name,
    //                     category_name: team.category_name,
    //                     shield: team.club.shield,
    //                     number: (parseInt(Object.keys(team.players).length) + parseInt(Object.keys(team.staff).length))
    //                 }
    //                 self.people[key] = oTeam;
    //                 console.log("ye");
    //                 self.loadPeople();
    //             });

    //         } else {
    //             var self = this;
    //             this.$store.dispatch( 'persons/load_by_id', { id: item.entity_id } ).then( function( person ){
    //                 var oPerson = {
    //                     entity_type: 3,
    //                     entity_id: item.entity_id,
    //                     name: person.name,
    //                     category_name: "",
    //                     shield: "",
    //                     number: 1
    //                 }
    //                 self.people[key] = oPerson;
    //                 self.loadPeople();
    //             });

    //         }

    //         this.peopleArrayLoad.pop()

    //         // this.loadPeople();

    //     } else {
    //         this.people = this.people;
    //         this.$overlay.hide();
    //     }
    // }
  },
  filters: {}
};
</script>

<style lang="scss" scoped>
#travel {
  width: 100%;
  display: inline-block;

  .container {
    width: calc(100%);
    padding: 0px;
    max-width: 100%;

    &.main {
      overflow-y: auto;
      height: calc(100vh - 110px);
    }

    .section-container {
      padding: 20px;

      &#basic {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      }
      &#notes {
        background-color: $complem-color-light;
      }
      &#teams {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: -3px, $b: 8px, $s: 0px, $c: #00000011);
      }
    }
  }

  .contact {
    width: 20%;
    width: 350px;
    padding: 20px;
  }

  .logo {
    width: 150px;
    height: 150px;
    border-radius: 50%;

    img {
      object-fit: contain;
      object-position: center;
      height: 100%;
      width: auto;
      margin: 0 auto;
      display: block;
      margin-top: 25px;
      opacity: 0.5;
    }
  }
  .info {
    .container {
      margin: 0;
      padding: 0 20px;
      padding-left: 40px;
      width: 100%;

      .section {
        margin-bottom: 25px;

        .name {
          font-weight: lighter;
          font-size: 24px;
          @include font-size(14px);
          border-bottom: 1px solid #ddd;
          margin: 10px 0 20px 0;
          color: $main-color;
          text-transform: uppercase;
          margin-bottom: 20px;
          border-bottom: 2px solid $complem-color-dark;
          color: $complem-color-dark;
        }

        .label {
          font-family: $text-light;
          @include font-size(14px);
          width: 40%;
          float: left;
          line-height: 20px;
        }

        .value {
          font-family: $text;
          font-weight: lighter;
          @include font-size(14px);
          width: 60%;
          float: left;
          margin-bottom: 10px;
        }

        .edit {
          background-image: url(/img/edit-b.svg);
          background-size: 15px;
          background-repeat: no-repeat;
          background-position: left center;
          position: absolute;
          right: 0;
          top: -5px;
          padding-left: 20px;
          text-transform: none;
          font-weight: bold;
        }
      }
    }

    &.role .name {
      position: relative;
      width: fit-content;
      cursor: pointer;

      &::after {
        content: "";
        width: 30px;
        height: 15px;
        background: url(/img/down.svg);
        background-repeat: no-repeat;
        background-size: 15px;
        background-position: center right;
        position: absolute;
      }
    }

    .person {
      display: inline-block;
      width: 100%;
      border-bottom: 1px solid #ddd;
      padding: 5px 10px;
      height: 60px;
      overflow: hidden;

      .avatar {
        float: left;
        width: 100px;
        cursor: pointer;

        .shield {
          height: 45px;
          width: 45px;
          margin: 2.5px;
        }

        .letter {
          line-height: 1.4;
          background-color: blue;
          border-radius: 100%;
          text-align: center;
          color: white;
          padding: 10px 15px;
          width: 45px;
          height: 45px;
          font-weight: bold;
          font-size: 19px;
          margin: 2.5px;
        }
      }

      .content {
        height: 50px;
        line-height: 50px;
        float: right;
        width: calc(100% - 100px);

        .entity-name {
          display: inline;
          cursor: pointer;
        }

        .actions {
          float: right;
          display: inline;
          margin-right: 10px;
          cursor: pointer;

          .remove {
            width: 25px;
            height: 50px;
            /* display: inline; */
            float: left;
            padding-top: 12px;
          }
          .bifurcation {
            content: " ";
            width: 25px;
            height: 50px;
            float: left;
            background-image: url(/img/bifurcation.svg);
            background-repeat: no-repeat;
            background-position: center;
            background-size: 25px;
          }
        }

        .pax {
          height: 50px;
          line-height: 50px;
          float: right;
          text-align: right;
          display: inline;

          .icon {
            display: inline-block;
            margin-top: 5px;
            height: 50px;
            vertical-align: sub;
          }

          .number {
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>
